module.exports = __webpack_public_path__ + "5a5a2824a5b2000f1e7eb767a916bd13.woff";